module.exports = "<section class=\"selectShipping\">\n    <xo-select-shipping done-fn=\"onComplete\" token=\"token\" shipping-change-feature=\"shippingChangeFeature\" back-uri=\"backUri\"></xo-select-shipping>\n</section>\n"


//////////////////
// WEBPACK FOOTER
// ./pages/xo-shipping/template.html
// module id = ./pages/xo-shipping/template.html
// module chunks = 0